import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import {
  ConditionTemplatesError,
  ConditionTemplatesRequest,
  ConditionTemplatesResponse,
} from '@/api/model';
import { removeEmptyParams } from '@/api/utils';

const KEY = {
  GET_CONDITION_TEMPLATES: 'GET_CONDITION_TEMPLATES',
} as const;

const request = {
  getConditionTemplates: async (
    { payload: { params } }: ConditionTemplatesRequest,
    signal?: AbortSignal,
  ) => {
    const { data } = await fetchClient.FCT.get<ConditionTemplatesResponse>(
      ENDPOINTS.FCT.CONDITION_TEMPLATE,
      {
        params: removeEmptyParams(params),
        signal,
      },
    );

    return data;
  },
};

const query = {
  useGetConditionTemplates: (
    { payload }: ConditionTemplatesRequest,
    config?: Partial<UseQueryOptions<ConditionTemplatesResponse, ConditionTemplatesError>>,
  ) =>
    useQuery<ConditionTemplatesResponse, ConditionTemplatesError>({
      queryFn: ({ signal }) => request.getConditionTemplates({ payload }, signal),
      queryKey: [KEY.GET_CONDITION_TEMPLATES, payload.params.organ],
      ...config,
    }),
};

export const conditionTemplate = {
  KEY,
  query,
  request,
};
